import { observer, inject } from "mobx-react";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";

type UserImageHeaderProps = {
    image_url: string;
};

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

function UserImageHeader({ image_url }: UserImageHeaderProps) {
    return (
        <span>
            <img className="header-small-round" src={image_url} />
        </span>
    );
}

type NavLinkProps = {
    show: boolean;
};

function NavLinks({ show }: NavLinkProps) {
    if (!show) return <span></span>;
    return (
        <Link to="/subjects" className={"nav-link"}>
            Subjects
        </Link>
    );
}

class SubjectListItemMenu extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.toggleAppBar = this.toggleAppBar.bind(this);

        this.state = {
            dropdownOpen: false,
            collapseOpen: false
        };
    }

    toggleDropdown() {
        this.setState({
            ...this.state,
            ...{
                dropdownOpen: !this.state.dropdownOpen
            }
        });
    }

    toggleAppBar() {
        this.setState({
            ...this.state,
            ...{
                collapseOpen: !this.state.collapseOpen
            }
        });
    }

    public render() {
        return (
            <React.Fragment>
                <PopupState variant="popover" popupId="demo-popup-menu">
                    {popupState => (
                        <React.Fragment>
                            <Button {...bindTrigger(popupState)}>
                                <i className="fa fa-cog" />
                            </Button>
                            <Menu {...bindMenu(popupState)}>
                                <MenuItem onClick={() => this.props.mark_complete(this.props.subjectHashKey)}>
                                    Mark Complete
                                </MenuItem>
                            </Menu>
                        </React.Fragment>
                    )}
                </PopupState>
            </React.Fragment>
        );
    }
}

const ObservedSubjectListItemMenu = observer(SubjectListItemMenu);
export { ObservedSubjectListItemMenu as SubjectListItemMenu };
